import React from 'react';
import { Box, VStack, Text, Flex } from '@chakra-ui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useGetCustomerQuery } from '../../api';
import LoadingState from '../../components/base/LoadingState';
import QRCode from 'react-qr-code';
import { formatAddress } from '../../utils/addressUtils';
import PageHeader from '../../components/base/PageHeader';

const OfficeAccessPage: React.FC = () => {
    const { t } = useTranslation();
    const { data: customer, isLoading } = useGetCustomerQuery();

    if (isLoading || !customer) {
        return <LoadingState message={t.pages.mail.loading} />;
    }

    const officeAddress = formatAddress(customer?.office_address);

    const description = officeAddress
        ? t.pages.mail.qrCodeDescriptionWithAddress.replace('{address}', officeAddress)
        : t.pages.mail.qrCodeDescription;

    return (
        <Box bg="gray.100" pb={{ base: 20, lg: 6 }} overflow="auto">
            {/* Кнопка назад и заголовок */}
            <PageHeader title={t.pages.mail.qrCodeTitle} backPath="/office" />

            <Flex h="full" align="center" justify="center" px={4}>
                <VStack gap={4} align="stretch" w={{ base: 'full', md: '600px' }}>
                    {/* Контент с QR кодом */}
                    <Box p={8} bg="white">
                        <VStack gap={6} align="center">
                            <Text fontSize="md" color="black" textAlign="center">
                                {description}
                            </Text>
                            <Box bg="white" display="flex" justifyContent="center" alignItems="center">
                                <QRCode value={customer?.personal_code || ''} size={300} />
                            </Box>
                        </VStack>
                    </Box>
                </VStack>
            </Flex>
        </Box>
    );
};

export default OfficeAccessPage;
